* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  margin-bottom: calc(var(--spacer) * 2);

  gz-title[id='title'] {
    margin-bottom: calc(var(--spacer) * 4);
  }

  gz-text[id='description'] {
    margin-bottom: calc(var(--spacer) * 2);
    line-height: 1.15;
  }
}

.wrapper {
  padding: 2px;
  display: block;

  .dropdown-container {
    --form-field-input-width: 400px;
    display: flex;
    flex-direction: row;

    label {
      width: 12%;
      font-size: var(--body-size);
      line-height: 32px;
    }

    gz-dropdown {
      width: 88%;
    }
  }
}

@media screen and (max-width: 1536px) {
  .wrapper {
    .dropdown-container {
      label {
        width: 20%;
      }
    }

    gz-dropdown {
      width: 88%;
    }
  }
}
